import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading',
    template: `
        <span class="inline-flex items-center text-slate-500">
            <app-loading-ring class="me-2"></app-loading-ring>
            <span>{{ 'translate_loading' | translate }}</span>
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LoadingComponent {}
